module.exports = __webpack_public_path__ + "img/ic_no_resultado.3651a564.png";